import './DataTableBody.css';
export var body = '_51sfnf0-3-12-1';
export var loading = '_51sfnf1-3-12-1';